import { WCMSElement } from '@astmpkg/common-functions';
import React from 'react';

const WCMSFooter = () => {
  return (
    <WCMSElement path={process.env.REACT_APP_WCMS_AWS_FOOTER_PATH} />
  )
}

export default WCMSFooter;